import React from "react";
import { Link } from 'react-router';
import { ROUTES } from "../../constants/routes";
import { useAuth } from "../../contexts/AuthContext";
import KickerEckLogo from "./KickerEckLogo";

const NavigationImp = () => {
  const { isAuthenticated, logout } = useAuth();

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link to={ROUTES.HOME} className="navbar-brand page-scroll">
            <KickerEckLogo />
          </Link>{" "}
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            {isAuthenticated ? (
              <>
                <li>
                  <Link to="/admin" data-testid="nav-admin-link">
                    Admin
                  </Link>
                </li>
                <li>
                  <a
                    href="#logout"
                    onClick={(e) => { e.preventDefault(); logout(); }}
                    data-testid="nav-logout-link"
                    style={{ opacity: 0.7 }}
                  >
                    Logout
                  </a>
                </li>
              </>
            ) : (
              <li>
                <Link
                  to={ROUTES.ADMIN_LOGIN}
                  data-testid="nav-admin-login-link"
                  style={{ opacity: 0.7 }}
                >
                  Admin-Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavigationImp;
